import React from "react";
import { FaEdit, FaCog } from "react-icons/fa";
import { motion } from "framer-motion";
import "bootstrap/dist/css/bootstrap.min.css";

const taxData = [
  { id: 1, name: "VAT", rate: "16%", status: "Active" },
  { id: 2, name: "GST", rate: "14%", status: "Active" },
  { id: 3, name: "HST", rate: "12%", status: "Active" },
];

const TaxRates = () => {
  return (
    <motion.div
      className=" card container py-3"
      initial={{ opacity: 0, y: 30 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4 }}
    >
      {/* HEADER */}
      <motion.h5
        className="fw-semibold mb-3 text-primary"
        initial={{ opacity: 0, x: -20 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ delay: 0.1 }}
      >
        Tax Rates
      </motion.h5>

      {/* CARD */}
      <motion.div
        className="card shadow-sm border-0"
        initial={{ opacity: 0, scale: 0.95 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.3 }}
      >
        <div className="card-header bg-white fw-semibold">
          Tax Rate List
        </div>

        <div className="card-body p-0">
          <table className="table align-middle mb-0">
            <thead className="table-light">
              <tr>
                <th><input type="checkbox" /></th>
                <th>Name</th>
                <th>Tax Rate</th>
                <th>Status</th>
                <th className="text-end">Actions</th>
              </tr>
            </thead>

            <tbody>
              {taxData.map((item, index) => (
                <motion.tr
                  key={item.id}
                  initial={{ opacity: 0, y: 15 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: index * 0.1 }}
                  whileHover={{ scale: 1.01 }}
                >
                  <td>
                    <input type="checkbox" />
                  </td>

                  <td>{item.name}</td>
                  <td>{item.rate}</td>

                  <td>
                    <motion.span
                      className="badge bg-success"
                      initial={{ scale: 0.8 }}
                      animate={{ scale: 1 }}
                      transition={{ delay: 0.2 }}
                    >
                      {item.status}
                    </motion.span>
                  </td>

                  <td className="text-end">
                    <motion.button
                      whileTap={{ scale: 0.8 }}
                      className="btn btn-sm btn-light me-2"
                    >
                      <FaEdit />
                    </motion.button>

                    <motion.button
                      whileHover={{ rotate: 90 }}
                      whileTap={{ scale: 0.8 }}
                      className="btn btn-sm btn-light"
                    >
                      <FaCog />
                    </motion.button>
                  </td>
                </motion.tr>
              ))}
            </tbody>
          </table>
        </div>
      </motion.div>
    </motion.div>
  );
};

export default TaxRates;